import IconWrapper from './icon-wrapper';

const normalIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.1 3H3.90002V17.3153L7.82061 14.7678C9.14595 13.9067 10.8541 13.9067 12.1794 14.7678L16.1 17.3153L16.1 3ZM3.90002 1C2.79545 1 1.90002 1.89543 1.90002 3V17.3153C1.90002 18.9021 3.65921 19.8569 4.98973 18.9924L8.91032 16.4449C9.57299 16.0143 10.4271 16.0143 11.0897 16.4449L15.0103 18.9924C16.3408 19.8569 18.1 18.9021 18.1 17.3153V3C18.1 1.89543 17.2046 1 16.1 1H3.90002Z"
      fill="#595959"
    />
    <path
      d="M9.12888 4.54557C9.51139 3.86693 10.4887 3.86693 10.8712 4.54557L11.6797 5.98008C11.8224 6.23325 12.0682 6.41183 12.3531 6.46931L13.9672 6.79499C14.7309 6.94907 15.0329 7.87852 14.5056 8.45202L13.3912 9.66428C13.1945 9.87823 13.1006 10.1672 13.134 10.4559L13.323 12.0917C13.4125 12.8655 12.6219 13.44 11.9135 13.1158L10.4162 12.4305C10.1519 12.3095 9.84813 12.3095 9.58386 12.4305L8.08656 13.1158C7.3782 13.44 6.58757 12.8655 6.67701 12.0917L6.86606 10.4559C6.89943 10.1672 6.80554 9.87823 6.60886 9.66428L5.49442 8.45202C4.96719 7.87852 5.26919 6.94907 6.03282 6.79499L7.64697 6.46931C7.93185 6.41183 8.17763 6.23325 8.32033 5.98008L9.12888 4.54557Z"
      fill="url(#paint0_linear_1517_7832)"
    />
    <defs>
      <linearGradient id="paint0_linear_1517_7832" x1="4" y1="3" x2="4" y2="15" gradientUnits="userSpaceOnUse">
        <stop stopColor="#B9B9B9" />
        <stop offset="1" stopColor="#7B7B7B" stopOpacity="0.01" />
      </linearGradient>
    </defs>
  </svg>
);
const activedIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.1 3H3.90002V17.3153L7.82061 14.7678C9.14595 13.9067 10.8541 13.9067 12.1794 14.7678L16.1 17.3153L16.1 3ZM3.90002 1C2.79545 1 1.90002 1.89543 1.90002 3V17.3153C1.90002 18.9021 3.65921 19.8569 4.98973 18.9924L8.91032 16.4449C9.57299 16.0143 10.4271 16.0143 11.0897 16.4449L15.0103 18.9924C16.3408 19.8569 18.1 18.9021 18.1 17.3153V3C18.1 1.89543 17.2046 1 16.1 1H3.90002Z"
      fill="#2D64FF"
    />
    <path
      d="M9.12888 4.54557C9.51139 3.86693 10.4887 3.86693 10.8712 4.54557L11.6797 5.98008C11.8224 6.23325 12.0682 6.41183 12.3531 6.46931L13.9672 6.79499C14.7309 6.94907 15.0329 7.87852 14.5056 8.45202L13.3912 9.66428C13.1945 9.87823 13.1006 10.1672 13.134 10.4559L13.323 12.0917C13.4125 12.8655 12.6219 13.44 11.9135 13.1158L10.4162 12.4305C10.1519 12.3095 9.84813 12.3095 9.58386 12.4305L8.08656 13.1158C7.3782 13.44 6.58757 12.8655 6.67701 12.0917L6.86606 10.4559C6.89943 10.1672 6.80554 9.87823 6.60886 9.66428L5.49442 8.45202C4.96719 7.87852 5.26919 6.94907 6.03282 6.79499L7.64697 6.46931C7.93185 6.41183 8.17763 6.23325 8.32033 5.98008L9.12888 4.54557Z"
      fill="url(#paint0_linear_1517_7840)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1517_7840"
        x1="4.11603"
        y1="3.30957"
        x2="2.71651"
        y2="14.6363"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00B3EE" />
        <stop offset="1" stopColor="#2BCAFF" stopOpacity="0.01" />
      </linearGradient>
    </defs>
  </svg>
);

export default function IconDaily() {
  return <IconWrapper normalIcon={normalIcon} activedIcon={activedIcon} />;
}
